<template>
  <div>
    <div class="d-flex justify-content-center mb-3">
      <h1 class="display-1">{{ name }}</h1>
    </div>
    <div class="mb-5">
      <h1 class="text-center headline">Progress Report</h1>
      <h3 class="text-center title">{{ formattedDate }}</h3>
    </div>
    <div>
      <div class="mb-5">
        <template v-if="data">
          <template v-if="data.length">
            <user-completed
              :data="data"
              :type="type"
              :dealerId="dealerId"
              :specificDealerId="specificDealerId"
            ></user-completed>
          </template>
          <template v-else>
            <user-completed :data="[]"></user-completed>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import UserCompleted from './UsersCompleted';
import dayjs from 'dayjs';

export default {
  components: {
    UserCompleted,
  },
  data() {
    return {
      data: null,
      name: null,
      type: null,
    };
  },
  mounted() {
    this.getReport();
  },
  methods: {
    getAccountManagerReport() {
      this.$http
        .get('/client/reports/account-manager/report', {
          params: {
            id:
              this.type !== 'account-manager'
                ? this.dealerId
                : this.specificDealerId,
            date: dayjs(this.date).format('YY-MM-DD'),
          },
        })
        .then((response) => {
          let reports = response.data.data;

          if (typeof reports) {
            this.data = Object.values(reports);
          } else {
            this.data = reports;
          }

          this.name = response.data.name;
          this.type = response.data.type;
        });
    },
    getSpecificManagerReport() {
      this.$http
        .get('/client/reports/specific-manager/report', {
          params: {
            id:
              this.type !== 'account-manager'
                ? this.dealerId
                : this.specificDealerId,
            date: dayjs(this.date).format('YY-MM-DD'),
          },
        })
        .then((response) => {
          let reports = response.data.data;

          if (typeof reports) {
            this.data = Object.values(reports);
          } else {
            this.data = reports;
          }

          this.name = response.data.name;
          this.type = response.data.type;
        });
    },
    getReport() {
      if (this.managerType === 'account-manager') {
        this.getAccountManagerReport();
      }

      if (this.managerType === 'specific-manager') {
        this.getSpecificManagerReport();
      }
    },
  },
  computed: {
    dealerId() {
      return this.$route.query.dealerId;
    },
    specificDealerId() {
      return this.$route.query.specificDealerId;
    },
    managerType() {
      return this.$route.query.type;
    },
    date() {
      return this.$route.query.date;
    },
    dealerId() {
      return this.$route.query.dealerId;
    },
    formattedDate() {
      return dayjs(this.date).format('MMMM DD YYYY');
    },

    data() {
      return this.data;
    },
  },
};
</script>
